import toArray from '../../helpers/toArray';

const Albums = {
  create(node, options) {
    this.node = node;
    this.options = options;

    this.$albumsList = $(this.node).find('.js-albums-list');
    this.$modal = $('#editAlbumModal');

    this.createEvents();
  },

  createEvents() {
    // Listen for opens on the album edit modals
    this.$modal.on('show.bs.modal', (e) => {
      if (e.relatedTarget) {
        const $album = this.getAlbum($(e.relatedTarget));

        const name = $album.find('.js-name').text();
        const id = parseInt($album.data('album-id'), 10);

        let parentId = parseInt($album.data('parent-id'), 10);
        parentId = !Number.isNaN(parentId) ? parentId : null;

        this.editAlbum({
          id,
          name,
          parentId,
        });
      }
    });

    // Listen for album deletions
    this.$albumsList.on('click', '.js-album-delete', (e) => {
      // Create and open a prompt
      window.prompt.create({
        title: 'Weet je het zeker?',
        btnSuccessText: 'Ja',
        btnCancelText: 'Nee',
      })
        .then(() => {
          $(e.currentTarget).parents('form').submit();
        }).catch(() => {});
    });

    this.$albumsList.on('change', '.js-album-check', (event) => {
      const { currentTarget } = event;
      const { checked } = currentTarget;

      this.toggleUnderlyingAlbums(currentTarget, checked);
    });
  },

  /**
   * Get album element
   * @param {Object} $el
   * @return {Object}
   */
  getAlbum($el) {
    return $el.parents('.js-album');
  },

  /**
   * Change info in edit modal
   * @param {object} albumInformation
   * @return {void}
   */
  editAlbum({ id, name, parentId }) {
    this.$modal.find('[name="title"]').val(name);
    this.$modal.find('[name="parent_id"]').val(parentId);

    const $form = this.$modal.find('form');

    $form.attr('action', $form.data('action').replace('{album_id}', id));
  },

  toggleUnderlyingAlbums(inputTarget, toggleState) {
    const listItem = inputTarget.closest('li');
    const albumItemsChecks = listItem
      ? toArray(listItem.querySelectorAll('.js-album-check'))
      : [];

    albumItemsChecks.forEach((check) => {
      check.checked = toggleState;
    });
  },
};

export default Albums;
